import { defineComponent as r, openBlock as t, createBlock as p, unref as a, mergeProps as l, withCtx as m, createElementVNode as c } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconChevronUp",
  __name: "IconChevronUp",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const n = o;
    return (d, e) => (t(), p(a(i), l(n, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        c("path", {
          "fill-rule": "evenodd",
          d: "m12 10.957 3.47 3.47a.75.75 0 1 0 1.06-1.06L12.884 9.72a1.25 1.25 0 0 0-1.768 0L7.47 13.366a.75.75 0 0 0 1.06 1.06L12 10.958",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
